import React from 'react';
import {ConfigApi, OrderType} from "../../../../../../../../services/Api/types";
import NavbarMulti from "../../../../../../../../components/Navbar/NavbarMulti";
import FetchPlaces from "../../../../../../../../components/Fetch/FetchPlaces";
import Footer from "../../../../../../../../components/layout/Footer/Footer";
import {getLanguagesBasedOnStoreType} from "../../../../../../../../services/languageUtils";
import MultistoreWithHomePageDeliverySection from "./Delivery/MultistoreWithHomePageDeliverySection";
import {useTranslation} from "react-i18next";
import MultistoreWithMapHomePageOtherTypesSection from "./MultistoreWithMapHomePageOtherTypesSection";
import {usePlaceContext} from "../../../../../../../../services/Place/PlaceContext";
import {getMultistoreOrderTypes} from "../../../../../../utils/multistoreUtils";
import MultistoreWithMapHomePageMenuSection from "./Menu/MultistoreWithMapHomePageMenuSection";

interface Props {
    config: ConfigApi
}

const MultistoreWithMapHomePage = ({config}: Props) => {
    const {t} = useTranslation();
    const {places} = usePlaceContext();
    const orderTypes = getMultistoreOrderTypes(places ?? []);

    return (
        <div className="multistore-home-page multistore-with-map-home-page" id="multistore-with-map-home-page">
            <NavbarMulti config={config}/>
            <FetchPlaces>
                <div className="inner-container">
                    <div className="container-fluid">
                        <div className="online-order-section">
                            <div className="online-order-section-inner-container">
                                <h1>{t("modules.multistore.field.order_online.title")}</h1>
                                <div className="online-order-section-cards">
                                    {orderTypes.includes(OrderType.DELIVERY) && (
                                        <MultistoreWithHomePageDeliverySection/>
                                    )}
                                    {
                                        orderTypes.length > 0 && orderTypes.some(orderType => orderType !== OrderType.DELIVERY) && (
                                            <MultistoreWithMapHomePageOtherTypesSection orderTypes={orderTypes}/>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <MultistoreWithMapHomePageMenuSection config={config} orderTypes={orderTypes}/>
                    </div>
                </div>
            </FetchPlaces>
            <Footer config={config} languages={getLanguagesBasedOnStoreType(config)} withoutMap/>
        </div>
    )
}

export default MultistoreWithMapHomePage;